export const ROUTER_STORE_NAME = "router";

export const DEFAULT_CLIENT_ROUTE = "/default";
